<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="driverName"
                    label="配送员姓名"
                >
                    <el-input
                        v-model="queryFormModel.driverName"
                        placeholder="请输入配送员姓名"
                    />
                </el-form-item>
                <el-form-item
                    prop="driverMobile"
                    label="配送员手机号"
                >
                    <el-input
                        v-model="queryFormModel.driverMobile"
                        placeholder="请输入配送员手机号"
                    />
                </el-form-item>
                <el-form-item
                    prop="orderSn"
                    label="订单号"
                >
                    <el-input
                        v-model="queryFormModel.orderSn"
                        placeholder="请输入订单号"
                    />
                </el-form-item>
                <el-form-item
                    prop="orderTime"
                    label="下单时间"
                >
                    <el-date-picker
                        :picker-options="$utils.CommonConfig.pickerOptions"
                        v-model="queryFormModel.orderTime"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    />
                </el-form-item>
                <el-form-item
                    prop="shippingTime"
                    label="开始配送时间"
                >
                    <el-date-picker
                        :picker-options="$utils.CommonConfig.pickerOptions"
                        v-model="queryFormModel.shippingTime"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    />
                </el-form-item>
                <el-form-item
                    prop="receiveTime"
                    label="配送完成时间"
                >
                    <el-date-picker
                        :picker-options="$utils.CommonConfig.pickerOptions"
                        v-model="queryFormModel.receiveTime"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-download"
                        size="small"
                        @click="exportOrderExcel"
                    >
                        导出
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
                @selection-change="onTableSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="36"
                />
                <el-table-column
                    prop="orderSn"
                    label="订单号"
                    min-width="100"
                />
                <el-table-column
                    prop="driverName"
                    label="配送员姓名"
                    min-width="100"
                />
                <el-table-column
                    prop="driverMobile"
                    label="配送员手机号"
                    min-width="100"
                />
                <el-table-column
                    label="下单时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.orderTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="出库时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.transferStockTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="开始配送时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.shippingTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="配送完成时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.receiveTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'DirverOrderList',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                driverName: '',
                driverMobile: '',
                orderSn: '',
                orderTime: '',
                shippingTime: '',
                receiveTime: '',
                shipMethodList: '8,16',
                orderStatus: '100',
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Ex.Order.orderList(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        onTableSelectionChange(val) {
            this.currentTableSelect = val;
        },
        exportOrderExcel() {
            let ids = '';
            if (this.currentTableSelect.length !== 0) {
                const idList = [];
                this.currentTableSelect.forEach(item => {
                    idList.push(item.id);
                });
                ids = idList.join(',');
            }
            let orderBeginTime = null;
            let orderEndTime = null;
            if (this.queryFormModel.orderTime != null && this.queryFormModel.orderTime.length === 2) {
                [orderBeginTime, orderEndTime] = this.queryFormModel.orderTime;
            }
            let receiveTimeBegin = null;
            let receiveTimeEnd = null;
            if (this.queryFormModel.receiveTime != null && this.queryFormModel.receiveTime.length === 2) {
                [receiveTimeBegin, receiveTimeEnd] = this.queryFormModel.receiveTime;
            }
            let shippingTimeBegin = null;
            let shippingTimeEnd = null;
            if (this.queryFormModel.shippingTime != null && this.queryFormModel.shippingTime.length === 2) {
                [shippingTimeBegin, shippingTimeEnd] = this.queryFormModel.shippingTime;
            }
            this.$http.href('/stat/driverStat/exportDriverOrderExcel', {
                ...this.queryFormModel,
                orderBeginTime,
                orderEndTime,
                receiveTimeBegin,
                receiveTimeEnd,
                shippingTimeBegin,
                shippingTimeEnd,
                ids,
            });
        },
    },
};
</script>

<style lang="scss">
</style>
